export default {
  data() {
    return {
      iranDomains: ['vtmarkets-pro.com', 'vtmarkets-fa.com', 'vt-fa.com'],
      platformUrl: '',
    }
  },
  methods: {
    redirectToLogin() {
      this.$router.push('/')
    },
  },
  beforeMount() {
    const isIranDomain = this.iranDomains.some(domain => window.location.origin.includes(domain))
    this.platformUrl = isIranDomain ? this.$config.info.getUrlIr('svg') : this.$config.info.getUrl('svg')
  },
}
